import { useIsFeedbackOnFeedbackEnabled } from '@modules/feedback/hooks';
import { MenuList, Stack } from '@mui/material';

interface FeedbackLabelsWrapperProps {
  shouldTruncateLabels?: boolean;
  children: React.ReactNode;
}

export const FeedbackLabelsWrapper = ({
  shouldTruncateLabels = false,
  children,
}: FeedbackLabelsWrapperProps) => {
  const { isFeedbackOnFeedbackEnabled } = useIsFeedbackOnFeedbackEnabled();

  if (!isFeedbackOnFeedbackEnabled) {
    return <>{children}</>;
  }

  return (
    <MenuList disableListWrap={shouldTruncateLabels} disablePadding>
      <Stack
        width="100%"
        direction={shouldTruncateLabels ? 'row' : 'column'}
        gap={isFeedbackOnFeedbackEnabled ? 0.25 : 1}
      >
        {children}
      </Stack>
    </MenuList>
  );
};
